const impressum = {
    title: "Impressum",
  
    sections: [
      {
        title: "Ansprechpartner",
        paragraphs: [
          "Prof. Dr. Christian Ressel",
          "Ambient Intelligent Systems",
          "Hochschule Rhein-Waal",
          "Telefon: +49 2842 908 25 241",
          "E-Mail: christian.ressel@hochschule-rhein-waal.de",
        ],
      },
  
      {
        title: "Anschrift",
        paragraphs: [
          "Hochschule Rhein-Waal",
          "Fakultät Kommunikation und Umwelt",
          "47475 Kamp-Lintfort",
          "Friedrich-Heinrich-Allee 25",
        ],
      },
  
      {
        title: "Rechtliche Daten",
        paragraphs: [
          "Die Hochschule Rhein-Waal ist eine Körperschaft des Öffentlichen Rechts. Sie wird durch das Präsidium gesetzlich vertreten.",
          "Dr. Oliver Locker-Grütjen, Präsident",
          "Zuständige Aufsichtsbehörde: Ministerium für Kultur und Wissenschaft (MKW), Völklinger Str. 49, 40221 Düsseldorf",
          "Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: DE815145426",
        ],
      },
  
      {
        title: "Umsatzsteuer-ID",
        paragraphs: [
          "Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:",
          "DE815145426",
        ],
      },
  
      {
        title: "Zuständige Aufsichtsbehörde",
        paragraphs: [
          "Ministerium für Kultur und Wissenschaft des Landes Nordrhein-Westfalen (MKW)",
          "Völklinger Straße 49",
          "40221 Düsseldorf",
          "Deutschland",
        ],
      },
    ],
  };
  
  export default impressum;